import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss'],
})
export class ImageViewerComponent implements OnInit {
  comment: string = '';
  file: any;
  isAfter: boolean = false;
  @Input() set selectedImage(value: any) {
    this.file = value.blobUrl;
    this.comment = value.comment;
    this.isAfter = value.isAfter;
  }
  @Input() showBeforeAfterTag: boolean = false;
  @Input() isImage: boolean;
  @Output() closeEvent = new EventEmitter();
  constructor() {}

  ngOnInit(): void {}

  dismiss() {
    this.closeEvent.emit();
  }
}
